import client from 'shared/api/axios'

export type Me = {
  username: string
  firstName: string
  lastName: string
  email: string
  lastLogin: string | null
  profile: {
    id: number
    language: string
    approvedAttachmentsConditions: boolean
  }
  expert: {
    approved: boolean
    confirmedAgreement: boolean
    editor?: {
      name?: string
      email?: string
    }
  }
}

export async function getMe(): Promise<Me> {
  const { data } = await client.get('/accounts/me/')

  return {
    username: data.username,
    firstName: data.first_name,
    lastName: data.last_name,
    email: data.email,
    lastLogin: data.last_login,
    profile: {
      id: data.profile.id,
      language: data.profile.language,
      approvedAttachmentsConditions:
        data.profile.approved_attachments_conditions,
    },
    expert: {
      approved: data.expert.approved,
      confirmedAgreement: data.expert.confirmed_agreement,
      editor: data.expert.editor
        ? {
            name: data.expert.editor.name ?? undefined,
            email: data.expert.editor.email ?? undefined,
          }
        : undefined,
    },
  }
}
